var _rect, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWatchCount(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 36,
    viewBox: "0 0 37 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.333344,
    width: 36,
    height: 36,
    rx: 8,
    fill: "#F4ECFB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.275 18.9339C11.2724 21.3161 12.4718 23.539 14.4644 24.8449C16.457 26.1508 18.9744 26.3638 21.1573 25.4104C23.3412 24.457 24.8965 22.4671 25.293 20.1176C25.6897 17.7682 24.8748 15.3774 23.1264 13.7597L24.0972 12.7933C24.2704 12.6201 24.2704 12.3387 24.0972 12.1655C23.924 11.9923 23.6434 11.9923 23.4702 12.1655L22.4389 13.1968C21.0256 12.1837 19.2885 11.7282 17.5609 11.9178C15.8325 12.1066 14.2348 12.9275 13.0754 14.2229C11.915 15.5175 11.2742 17.195 11.275 18.9339ZM17.8901 17.6462V14.9124H18.7768V18.934C18.7768 19.1791 18.5785 19.3774 18.3335 19.3774C18.0884 19.3774 17.8901 19.179 17.8901 18.934V17.6462Z",
    fill: "#883DCF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0144 10H20.6543V10.8867H16.0144V10Z",
    fill: "#883DCF"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWatchCount);
export default __webpack_public_path__ + "static/media/watchCount.ecd5ac7ebb49e12b2c5733c3c98c5bef.svg";
export { ForwardRef as ReactComponent };